import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationsEN from "./assets/locales/en/translations.json";
import translationsLT from "./assets/locales/lt/translations.json";

const resources = {
  en: {
    translation: translationsEN,
  },
  lt: {
    translation: translationsLT,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "lt",
    resources,
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  })
  .catch(error => {
    console.error("i18n initialization failed", error);
  });

i18n.on("languageChanged", lng => {
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.language;

export default i18n;
